export const DEVELOPMENT_GTM_ID = 'GTM-ID';
export const PRODUCTION_GTM_ID = 'GTM-WDW3F5';

export const SLIDE_SPEED_IN_MS = 250;
export const CARD_ANIMATION_SPEED_IN_MS = 250; // animation.scss -> $atom-animation-duration
